/* Avis clients avec photo (01/11/2026). Lit /apps/bb/avis-liste, envoie /apps/bb/avis-soumettre,
 * vote /apps/bb/avis-vote. Le balisage vient du snippet Liquid (un <template> par carte) : ce
 * script ne fabrique aucun HTML, il remplit. Photo réduite dans le navigateur avant envoi. */
(function () {
/* Chaque rubrique avis de la page (témoignages des fiches ET « Ils nous font confiance ») a son
 * propre bloc, fonctionnel : Arthur veut pouvoir laisser un avis depuis chacune. */
document.querySelectorAll('[data-fn-ugc]').forEach(function (racine) {
  if (racine.dataset.fnUgcPret) return; racine.dataset.fnUgcPret = '1';
  var idx = Array.prototype.indexOf.call(document.querySelectorAll('[data-fn-ugc]'), racine);
  if (idx > 0) racine.querySelectorAll('.fn-ugc__notes input, .fn-ugc__notes label').forEach(function (el) { if (el.id) el.id = el.id + '-' + idx; if (el.htmlFor) el.htmlFor = el.htmlFor + '-' + idx; });
  var BASE = '/apps/bb/';
  var produit = racine.dataset.produit || '', langue = racine.dataset.langue || 'fr', pays = racine.dataset.pays || '', tous = racine.dataset.tous === '1';
  var liste = racine.querySelector('[data-fn-ugc-liste]'), vide = racine.querySelector('[data-fn-ugc-vide]'), tpl = racine.querySelector('[data-fn-ugc-carte]');
  var dialog = racine.querySelector('[data-fn-ugc-dialog]'), form = racine.querySelector('[data-fn-ugc-form]');
  var T = {}; racine.querySelectorAll('[data-fn-ugc-t]').forEach(function (s) { T[s.dataset.cle] = s.textContent; });
  var CLE_VOTES = 'fn_ugc_votes'; var votes = {}; try { votes = JSON.parse(localStorage.getItem(CLE_VOTES) || '{}'); } catch (e) {}

  function etoiles(el, n) { el.textContent = ''; el.setAttribute('aria-label', n + ' ' + (T.sur5 || '/5'));
    for (var i = 1; i <= 5; i++) { var s = document.createElement('span'); s.textContent = '★'; if (i > n) s.className = 'off'; el.appendChild(s); } }
  function dateLisible(iso) { try { return new Intl.DateTimeFormat(langue, { month: 'long', year: 'numeric' }).format(new Date(iso)); } catch (e) { return iso || ''; } }

  function stats(avis) {
    var el = racine.querySelector('[data-fn-ugc-stats]'); if (!el || avis.length < 3) return;
    var moy = avis.reduce(function (s, a) { return s + (Number(a.note) || 0); }, 0) / avis.length;
    var note = (Math.round(moy * 10) / 10).toLocaleString(langue, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    el.querySelector('.fn-ugc__stats-etoiles').textContent = '★★★★★'.slice(0, Math.round(moy)) + '☆☆☆☆☆'.slice(0, 5 - Math.round(moy));
    el.querySelector('[data-fn-ugc-stats-texte]').textContent = (T.stats || '{n} · {note}/5').replace('{n}', String(avis.length)).replace('{note}', note);
    el.hidden = false;
  }
  function rendre(avis) {
    liste.textContent = '';
    if (!avis.length) { vide.hidden = false; return; }
    vide.hidden = true;
    stats(avis);
    /* Les photos d'abord : c'est ce qui convainc. Puis les plus récents. */
    avis = avis.slice().sort(function (a, b) { return ((b.photo ? 1 : 0) - (a.photo ? 1 : 0)) || String(b.date).localeCompare(String(a.date)); });

    avis.forEach(function (a) {
      var n = tpl.content.cloneNode(true), carte = n.querySelector('.fn-ugc__carte');
      etoiles(n.querySelector('[data-stars]'), a.note);
      n.querySelector('[data-texte]').textContent = a.texte;
      n.querySelector('[data-nom]').textContent = a.prenom;
      n.querySelector('[data-ville]').textContent = a.ville || '';
      var t = n.querySelector('[data-date]'); t.textContent = a.date ? dateLisible(a.date) : ''; if (a.date) t.setAttribute('datetime', a.date);
      if (a.photo) {
        var fig = n.querySelector('[data-photo]'); fig.hidden = false;
        var img = n.querySelector('[data-img]'); img.src = a.photo; img.alt = a.prenom;
        var btn = n.querySelector('[data-vote]'); btn.querySelector('[data-votes]').textContent = a.votes || 0;
        if (votes[a.id]) btn.setAttribute('aria-pressed', 'true');
        btn.addEventListener('click', function () { voter(a.id, btn); });
      }
      liste.appendChild(n);
    });
  }
  function charger() {
    var u = BASE + 'avis-liste?langue=' + encodeURIComponent(langue) + (tous ? '&tous=1' : '&produit=' + encodeURIComponent(produit));
    fetch(u, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (d) { rendre((d && d.avis) || []); }).catch(function () { vide.hidden = false; });
  }
  function voter(id, btn) {
    if (votes[id]) return;
    fetch(BASE + 'avis-vote', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: id }) })
      .then(function (r) { return r.json(); }).then(function (d) {
        if (!d || !d.ok) return;
        votes[id] = 1; try { localStorage.setItem(CLE_VOTES, JSON.stringify(votes)); } catch (e) {}
        btn.setAttribute('aria-pressed', 'true'); btn.querySelector('[data-votes]').textContent = d.votes; btn.title = T.vote_merci || '';
      }).catch(function () {});
  }

  /* Photo : réduite à 1 400 px et recompressée en JPEG, pour rester sous 1,5 Mo dans le POST. */
  var photoData = '';
  function reduire(file) {
    return new Promise(function (res) {
      if (!file || !/^image\/(jpeg|png|webp)$/.test(file.type)) return res('');
      var img = new Image(), url = URL.createObjectURL(file);
      img.onload = function () {
        var max = 1400, w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, max / Math.max(w, h));
        var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height); URL.revokeObjectURL(url);
        var q = 0.82, out = c.toDataURL('image/jpeg', q);
        while (out.length > 1.4 * 1024 * 1024 && q > 0.5) { q -= 0.1; out = c.toDataURL('image/jpeg', q); }
        res(out.length > 1.7 * 1024 * 1024 ? '' : out);
      };
      img.onerror = function () { URL.revokeObjectURL(url); res(''); };
      img.src = url;
    });
  }
  var inputPhoto = racine.querySelector('[data-fn-ugc-photo]'), apercu = racine.querySelector('[data-fn-ugc-apercu]');
  if (inputPhoto) inputPhoto.addEventListener('change', function () {
    reduire(inputPhoto.files && inputPhoto.files[0]).then(function (d) {
      photoData = d; apercu.hidden = !d; if (d) apercu.src = d;
      var lab = racine.querySelector('[data-fn-ugc-photo-label]'); if (lab && d) lab.textContent = T.photo_choisie || lab.textContent;
      if (!d && inputPhoto.files && inputPhoto.files[0]) erreur(T.photo);
    });
  });

  var erreurEl = racine.querySelector('[data-fn-ugc-erreur]');
  function erreur(msg) { erreurEl.textContent = msg || T.erreur_generale || ''; erreurEl.hidden = !msg; }
  racine.querySelector('[data-fn-ugc-ouvrir]').addEventListener('click', function () { erreur(''); if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', ''); });
  racine.querySelector('[data-fn-ugc-fermer]').addEventListener('click', function () { dialog.close ? dialog.close() : dialog.removeAttribute('open'); });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });

  form.addEventListener('submit', function (e) {
    e.preventDefault(); erreur('');
    var f = new FormData(form), texte = String(f.get('texte') || '').trim();
    if (texte.length < 20) return erreur(T.texte_court);
    if (!form.querySelector('[name=consent]').checked) return erreur(T.erreur_generale);
    var btn = racine.querySelector('[data-fn-ugc-envoyer]'); btn.disabled = true;
    var corps = { produit: produit, note: Number(f.get('note') || 5), texte: texte, prenom: f.get('prenom'), ville: f.get('ville'), email: f.get('email'),
      langue: langue, pays: pays, consent: true, photo: photoData || undefined, hp: f.get('hp') || '' };
    fetch(BASE + 'avis-soumettre', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(corps) })
      .then(function (r) { return r.json().then(function (d) { return { s: r.status, d: d }; }); })
      .then(function (x) {
        btn.disabled = false;
        if (x.d && x.d.ok) { form.querySelectorAll('input,textarea,button[type=submit]').forEach(function (el) { el.disabled = true; }); racine.querySelector('[data-fn-ugc-merci]').hidden = false; return; }
        var r = (x.d && x.d.raison) || '';
        erreur(r === 'deja' ? T.deja : r === 'texte_court' ? T.texte_court : r === 'photo' ? T.photo : r === 'debit' ? T.debit : T.erreur_generale);
      }).catch(function () { btn.disabled = false; erreur(T.erreur_generale); });
  });

  charger();
});
/* Un bouton ailleurs sur la page (en-tête de la page avis) ouvre le premier bloc. */
document.addEventListener('click', function (e) {
  var a = e.target.closest('[data-fn-ugc-ouvrir-distant]'); if (!a) return;
  var bloc = document.querySelector('[data-fn-ugc]'); if (!bloc) return;
  e.preventDefault(); bloc.scrollIntoView({ behavior: 'smooth', block: 'start' });
  var btn = bloc.querySelector('[data-fn-ugc-ouvrir]'); if (btn) setTimeout(function () { btn.click(); }, 450);
});
})();
